type SearchableContractItem = {
  readonly buyerArticleId?: string | null;
  readonly manufacturer?: string | null;
  readonly position?: number | null;
  readonly productDescription?: string | null;
  readonly productName?: string | null;
  readonly sellerArticleId?: string | null;
  readonly unitType?: string | null;
};

export function filterContractItems<T extends SearchableContractItem>(
  items: T[],
  searchString: string,
  unitTranslations: Record<string, string>,
): T[] {
  const normalizedSearch = searchString.trim().toLowerCase();

  if (!normalizedSearch) {
    return items;
  }

  return items.filter((item) => {
    const searchableValues = [
      item.position?.toString(),
      item.buyerArticleId,
      item.sellerArticleId,
      item.productName,
      item.productDescription,
      item.manufacturer,
      unitTranslations[item.unitType ?? ''],
    ];

    return searchableValues.some((value) =>
      value?.toLowerCase().includes(normalizedSearch),
    );
  });
}
